/* Irish market (/en-ie): show euro amounts the Irish way (19.96, 1,234.56).
   Shopify formats presentment EUR with a decimal comma ("€19,96") and the format is not editable,
   so this rewrites euro text on screen only. Loaded only when the market subfolder is /en-ie
   and the currency is EUR (layout/theme.liquid). Structured data is already "19.96". */
(function () {
  var RE = /€\s?(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})(?!\d)/g;
  function fix(text) {
    return text.replace(RE, function (_, whole, cents) { return '€' + whole.replace(/\./g, ',') + '.' + cents; });
  }
  function walk(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return n.nodeValue.indexOf('€') > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var n;
    while ((n = w.nextNode())) {
      var v = fix(n.nodeValue);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('option, [aria-label*="€"]').forEach(function (el) {
        var a = el.getAttribute('aria-label');
        if (a && a.indexOf('€') > -1) el.setAttribute('aria-label', fix(a));
      });
    }
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') {
          var v = fix(m.target.nodeValue || '');
          if (v !== m.target.nodeValue) m.target.nodeValue = v;
        } else {
          m.addedNodes.forEach(function (n) { walk(n.nodeType === 3 ? n.parentNode : n); });
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
